import { AssetCatalogTableSkeleton } from '@/features/admin-dashboard/components/AssetCatalogTableSkeleton';
import { Skeleton } from '@/shared/components/ui/skeleton';

/** Route-level pending shape for AdminDashboard → Assets: header, summary line, table. */
export function AdminDashboardAssetsSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-3 p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="space-y-1">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-3 w-64" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-7 w-20 rounded-md" />
          <Skeleton className="h-7 w-40 rounded-md" />
        </div>
      </div>
      <div className="flex justify-end">
        <Skeleton className="h-3 w-40" />
      </div>
      <AssetCatalogTableSkeleton />
    </div>
  );
}
